import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type IndeedFlexJobShiftWorkerBookingType =
  | 'scheduled'
  | 'removed'
  | 'indeed_flex_only'

export type IndeedFlexJobShiftWorker = {
  associationId: number | null
  workerId: number | null
  workerName: string | null
  wwStatus: string | null
  wwStartedAt: string | null
  wwCompletedAt: string | null
  wwBreakDurationMinutes: number | null
  ifWorkerId: number | null
  ifBookingType: IndeedFlexJobShiftWorkerBookingType | null
  ifClockInTime: string | null
  ifClockOutTime: string | null
  ifBreakDurationMinutes: number | null
  ifNoShowReasonId: number | null
  ifNoShowReasonCode: string | null
  ifNoShowReasonDescription: string | null
  shouldBeBailed: boolean | null
}

export type IndeedFlexJobShiftItem = {
  ifClientId: number
  clientName: string
  ifJobId: number
  ifShiftId: number
  ifRoleId: number
  ifVenueId: number
  roleName: string | null
  venueName: string
  timezone: string
  startTime: string
  endTime: string
  allocationWithoutBuffer: number
  reportedDemandBuffer: number
  associationType: string
  workShiftId: number | null
  workShiftCancelled: boolean
  companyId: number | null
  companyName: string | null
  companyLocationId: number | null
  companyLocationName: string | null
  companyPositionId: number | null
  companyPositionName: string | null
  assignmentId: number | null
  assignmentName: string | null
  workers: IndeedFlexJobShiftWorker[]
  issues: string[]
}

type ListIndeedFlexJobShiftsRequest = {
  ifJobId: number
}

export type ListIndeedFlexJobShiftsResponse = {
  items: IndeedFlexJobShiftItem[]
}

export const listIndeedFlexJobShifts = async (
  request: ListIndeedFlexJobShiftsRequest
): Promise<ListIndeedFlexJobShiftsResponse> => {
  const params = {
    if_job_id: request.ifJobId,
  }

  const response = await api.get<ListIndeedFlexJobShiftsResponse>(
    '/admin/indeed_flex/job_shifts',
    { params, paramsSerializer: queryParamSerializer }
  )
  return response.data
}
